import React from "react";
import ReactQueryParams from "react-query-params";
import apiProxy from "../../api/apiProxy.js";
import AlertsPage from "./AlertsPage";
import validateQueryParams from "./validateQueryParams.js";
import { Redirect } from "react-router-dom";
import * as DefaultRoutes from "../../utils/defaultRoutes";
import LoadingWrapper from "../LoadingWrapper";
import PageTitle from "../PageTitle";

const alertsPageSize = 50;

class AlertsPageWrapper extends ReactQueryParams {
  state = {
    pagedAlerts: {},
    isLoading: true,
    list: {
      isLoading: false,
      isPaging: false
    },
    alertStatuses: [],
    alertSortOptions: []
  };

  defaultQueryParams = {
    status: ["Open"],
    sortBy: "Value_Desc",
    storeId: ""
  };

  componentDidMount() {
    this.loadAlertsWithStatuses();
  }

  loadAlerts = () => {
    const list = this.state.list;
    list.isLoading = true;
    this.setState({ list: list, alertsLoading: true });

    const after = "";
    const filterStatus = this.queryParams.status;
    const sortBy = this.queryParams.sortBy;
    const storeId = this.queryParams.storeId;

    apiProxy.alert
      .getAlerts(after, filterStatus, storeId, sortBy, alertsPageSize)
      .then(response => {
        list.isLoading = false;
        this.setState({
          pagedAlerts: response.alerts,
          alertStatuses: response.statuses,
          list: list
        });
      })
      .catch(response => {
        this.props.onError(response);
      });
  };

  loadAlertsWithStatuses = () => {
    this.setState({ isLoading: true });
    const after = this.state.pagedAlerts.after;

    const sortBy =
      this.queryParams.sortBy === null
        ? this.defaultQueryParams.sortBy
        : this.queryParams.sortBy;

    const status =
      !this.queryParams.status || this.queryParams.status.length === 0
        ? this.defaultQueryParams.status
        : this.queryParams.status;

    this.setQueryParams({
      status: status,
      sortBy: sortBy,
      storeId: this.queryParams.storeId
    });
    const filterStatus = status;
    const storeId = this.queryParams.storeId;

    apiProxy.alert
      .getAlerts(after, filterStatus, storeId, sortBy, alertsPageSize)
      .then(response => {
        const statuses = response.statuses;
        this.setState({
          pagedAlerts: response.alerts,
          alertStatuses: statuses,
          alertSortOptions: response.sortOptions,
          isLoading: false
        });
      })
      .catch(response => {
        this.props.onError(response);
      });
  };

  pageAlerts = () => {
    const list = this.state.list;
    list.isPaging = true;
    this.setState({ list: list });

    const after = this.state.pagedAlerts.after;
    const filterStatus = this.queryParams.status;
    const sortBy = this.queryParams.sortBy;
    const storeId = this.queryParams.storeId;

    apiProxy.alert
      .getAlerts(after, filterStatus, storeId, sortBy, alertsPageSize)
      .then(response => {
        const alerts = response.alerts;

        const alertItems = this.state.pagedAlerts.items;
        alertItems.push(...response.alerts.items);

        alerts.items = alertItems;

        list.isPaging = false;
        this.setState({ pagedAlerts: alerts, list: list });
      })
      .catch(response => {
        this.props.onError(response);
      });
  };

  clearPaging = () => {
    const pagedAlerts = this.state.pagedAlerts;
    pagedAlerts.after = "";

    this.setState({ pagedAlerts: pagedAlerts });
  };

  searchAlerts = (searchText, onAlertFound, onAlertNotFound) => {
    const list = this.state.list;
    list.isLoading = true;
    this.setState({ list: list, alertsLoading: true });

    apiProxy.alert
      .getAlert(searchText)
      .then(response => {
        list.isLoading = false;

        const alerts = [];
        alerts.push(response);

        const pagedAlerts = {
          after: null,
          items: alerts,
          pageSize: alertsPageSize,
          totalItemCount: 1
        };

        this.setState({
          pagedAlerts: pagedAlerts,
          list: list
        });

        if (onAlertFound) {
          onAlertFound();
          return;
        }
      })
      .catch(response => {
        list.isLoading = false;

        this.setState({ list: list });

        switch (response.status) {
          case 404:
            if (onAlertNotFound) {
              onAlertNotFound();
              return;
            }
            break;
          default:
            break;
        }

        this.props.onError(response);
      });
  };

  handleSortOptionChange = option => {
    this.setQueryParams({ sortBy: option.value });
  };

  handleStatusAdd = name => {
    const status = this.queryParams.status;
    status.push(name);

    this.setQueryParams({ status: status });
  };

  handleStatusRemove = index => {
    const status = this.queryParams.status;
    status.splice(index, 1);

    this.setQueryParams({ status: status });
  };

  handleStoreIdChange = storeId => {
    this.setQueryParams({ storeId: storeId });
  };

  render() {
    if (!validateQueryParams(this.queryParams)) {
      return <Redirect to={DefaultRoutes.DEFAULT_ALERT_ROUTE} />;
    }

    return (
      <PageTitle title="Alerts">
        <LoadingWrapper isLoading={this.state.isLoading}>
          <AlertsPage
            alertSortOptions={this.state.alertSortOptions}
            isLoading={this.state.isLoading}
            pagedAlerts={this.state.pagedAlerts}
            list={this.state.list}
            alertStatuses={this.state.alertStatuses}
            loadAlerts={this.loadAlerts}
            pageAlerts={this.pageAlerts}
            clearPaging={this.clearPaging}
            onStatusAdd={this.handleStatusAdd}
            onStatusRemove={this.handleStatusRemove}
            onStoreIdChange={this.handleStoreIdChange}
            onSortOptionChange={this.handleSortOptionChange}
            status={this.queryParams.status}
            queryParams={this.queryParams}
            storeId={this.queryParams.storeId || null}
            selectedSortOptionCode={
              this.queryParams.sortBy === null
                ? this.defaultQueryParams.sortBy
                : this.queryParams.sortBy
            }
            searchAlerts={this.searchAlerts}
            stores={this.props.stores}
          />
        </LoadingWrapper>
      </PageTitle>
    );
  }
}

export default AlertsPageWrapper;
